angular.module('app.config').config(($logProvider, app) => {
    $logProvider.debugEnabled(app.debug);
});
